// For now, we can use Emotion's is-prop-valid package which exposes a single
// function that tests whether a prop is a valid HTML attribute name, and can
// therefore be applied to a base HTML element
export { default as isValidHtmlProp } from '@emotion/is-prop-valid';
